import { useState } from "react";
import { decisionCapabilities } from "@/data/siteData";

export default function DecisionLoop() {
  const [activeId, setActiveId] = useState(decisionCapabilities[0].id);
  const active = decisionCapabilities.find((item) => item.id === activeId) || decisionCapabilities[0];

  return (
    <div className="decision-loop" data-testid="decision-intelligence-loop">
      <div className="loop-grid">
        {decisionCapabilities.map((item) => (
          <button key={item.id} type="button" className={`loop-step ${activeId === item.id ? "active" : ""}`} data-testid={`decision-loop-node-${item.id}`} onClick={() => setActiveId(item.id)}>
            <span className="loop-index"><span>{item.number}</span><span>↗</span></span>
            <span className="loop-name">{item.name}</span>
          </button>
        ))}
      </div>
      <div className="loop-detail" data-testid="decision-loop-detail">
        <p className="loop-question">{active.question}</p>
        <p>{active.copy}</p>
      </div>
      <div className="governance-line">
        <span>Data provenance</span>
        <span>Semantic trust</span>
        <span>Accountability</span>
        <span>Outcome feedback</span>
      </div>
    </div>
  );
}
